import { render, staticRenderFns } from "./MentionsPanel.vue?vue&type=template&id=895f2e50&scoped=true&"
import script from "./MentionsPanel.vue?vue&type=script&lang=js&"
export * from "./MentionsPanel.vue?vue&type=script&lang=js&"
import style0 from "./MentionsPanel.vue?vue&type=style&index=0&id=895f2e50&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "895f2e50",
  null
  
)

export default component.exports